module.exports = __webpack_public_path__ + "static/media/p-u-banner.81d4eb94.jpg";